import React, { useContext, useEffect, useState } from 'react';
import EnhancedTable from '../components/EnhancedTable';
import { getData } from '../utils/apiUtils';
import { getCurrentYear } from '../utils/dateUtils';
import { ErrorContext } from "../utils/constants";

const currentApprovalHeadCells = [
  { id: 'initiative_name', numeric: false, disablePadding: false, label: 'Initiative Name' },
  { id: 'id', true: false, disablePadding: false, label: 'Initiative Number' },
  { id: 'status', numeric: false, disablePadding: true, label: 'Status' },
  { id: 'max_date', numeric: false, disablePadding: true, label: 'Due Date', format: 'date' },
  { id: 'netCash', numeric: false, disablePadding: true, label: `Net Cash in ${getCurrentYear()}`, format: 'currency' },
];

export default function ApproverView()  {
  const [ currentApprovals, setCurrentApprovals ] = useState([]);
  const [ previousApprovals, setPreviousApprovals ] = useState([]);
  const { triggerError } = useContext(ErrorContext);

  const onError = () => triggerError({
      title: 'Communication Error',
      description: 'We were unable to read your current and previous approvals data from the server. Please try again.',
      onRetry: () => window.location.reload(),
  });

  const fetchData = () => {
      getData('/dashboards/mycurrentapprovals?current=true', setCurrentApprovals, onError);
      getData('/dashboards/mypreviousapprovals', setPreviousApprovals, onError);
  };

  useEffect(() => {
    fetchData();
    document.title = 'Rise by TransAlta Approvers Dashboard';
  }, []);

  return (
    <main>
      <h2>Initiatives Requiring Your Approval</h2>
      Here are the initiatives that are seeking your review and approval.
      <EnhancedTable id='195732d3-cbcf-474b-aa7f-b2ae05333584'
                     headCells={currentApprovalHeadCells}
                     rows={currentApprovals}
                     allowExport={true}
                     exportFilename='Initiatives Requiring Your Approval'
                     clickData={{url: '/ui/initiativecard/', key: 'id'}}/>
      <p/>
      <h2>Previous Approvals</h2>
      Here is a list of the initiatives you have previously approved this year.
      <EnhancedTable id='617885a8-6813-4699-af80-405ec1ded52c'
                     headCells={currentApprovalHeadCells}
                     rows={previousApprovals}
                     allowExport={true}
                     exportFilename='Previous Approvals'
                     clickData={{url: '/ui/initiativecard/', key: 'id'}}/>
    </main>
  );
}
